import { render, staticRenderFns } from "./AddNoContact.vue?vue&type=template&id=234fb1fb&scoped=true&"
import script from "./AddNoContact.vue?vue&type=script&lang=js&"
export * from "./AddNoContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234fb1fb",
  null
  
)

export default component.exports